<template>
    <div class="photo-frame">
        <div class="photo-frame-inner-wrap">
            <div @click="toggleModal(true)" class="photo-frame-img" :style="{ 'background-image' : `url(${src})` }"></div>
            <div class="frame-geolocation" v-if="location">
                <img style="width:20px; height:20px;" :src="getImageUrl('map_pin.svg')">
                <a :href="locationHref" target="_"><p>{{location}}</p></a>
            </div>
            <div class="frame-blurb-wrap">
                <p class="frame-blurb">{{text}}</p>
            </div>
        </div>
        <modal v-if="showModal" @close="showModal = false">
            <img class="photo-frame-img modal-img" :src="src"/>
        </modal>
    </div>
</template>

<script>
    export default {
        name: "PhotoFrame",
        components: {

        },
        props: {
            src: String,
            location: String,
            locationHref: String,
            text: String
        },
        data () {
            return {
                showModal: false
            } 
        },
        computed: {

        },
        methods: {
            toggleModal (status) {
                this.showModal = status
            }
        }    
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/variables";
    .photo-frame {
        margin-bottom: 20px;
        padding: 0 10px;
        font-family: 'Patrick Hand SC', cursive;

        .photo-frame-inner-wrap {
            margin: auto;
            box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
            padding: 10px;

            .photo-frame-img {
                cursor: pointer;
                max-width: 100%;
                height: 200px;
                background-size: cover;
                background-position: center;
            }

            .frame-geolocation {
                margin-top: 7px;
                display: flex;
                align-content: center;

                a { color: black; }
                p { margin: 0; padding-left: 10px; }
            }

            img {
                max-width: 100%;
            }

            .frame-blurb {
                cursor: initial;
            }
        }
    }

    .modal-img {
        max-width: min(calc(100vw - 25px), 500px);
        max-height: min(calc(100vh - 100px), 675px);
    }
</style>
